<template>
  <ArrowIcon :class="className" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import ArrowIcon from '@/components/icons/arrow'

export default {
  name: 'FluctuationIcon',
  components: {
    ArrowIcon,
  },
  props: {
    type: {
      type: Number,
      validator: type => [0, 1, 2, null].includes(type),
    },
  },
  computed: {
    className() {
      switch (this.type) {
        case 0:
          return 'keep'
        case 1:
          return 'up'
        case 2:
          return 'down'
        default:
          return 'none'
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.keep {
  fill: #3aa756;
  transform: rotate(180deg);
}

.up {
  fill: #3aa756;
  transform: rotate(90deg);
}

.down {
  fill: var(--pure-red);
  transform: rotate(-90deg);
}
.none {
  display: none;
}
</style>
